import { isNoEmptyString } from 'Lib/is-no-empty-string/is-no-empty-string';

export function showPopupError(message) {
    const defaultMessage = 'Попробуйте еще раз или обратитесь в службу технической поддержки.';

    $.fancybox.open(`
        <div>
            <p class="text text_c-gray">Ошибка</p>
            <p>"${(isNoEmptyString(message)) ? message : defaultMessage}"</p>
        </div>
    `);
}